import type { User } from '@/models'
import type { FetchEkioskQuerySuccess } from '@/services/types'
import type { RootState } from '@/state/reducer'
import { cleanLoggedInUser, setLoggedInUser } from '@/utils/auth'

import { injectEndpoints } from './base'
import { endpoints } from './endpoints'

interface LoginPayload {
  emailAddress: string
  password: string
  recaptchaCheckboxToken: string
}

export type LoginResponse = FetchEkioskQuerySuccess<{
  token?: string
  data?: User
}>

type LogInRawResponse = FetchEkioskQuerySuccess<{
  token?: string
  account: {
    user: User
  }
}>

export const authApi = injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginPayload, LogInRawResponse>({
      query: (user) => ({
        url: endpoints.SIGN_IN,
        method: 'POST',
        body: user,
      }),
      transformResponse: (response) => {
        const { token, account } = response
        const payload = {
          token,
          data: account?.user,
        }
        setLoggedInUser(payload)

        return payload
      },
    }),
    logout: builder.mutation<unknown, void>({
      query: () => ({
        url: endpoints.SIGN_OUT,
        method: 'POST',
        body: {},
      }),
      transformResponse: (response: unknown) => {
        cleanLoggedInUser()
        return response
      },
    }),
  }),
})

export const {
  useLoginMutation,
  useLogoutMutation,
  endpoints: {
    login: { matchFulfilled: loginFulfilled },
    logout: { matchFulfilled: logoutFulfilled },
  },
} = authApi

export const selectAuth = (state: RootState) => state.auth
